import * as _ from 'underscore';
import * as moment from 'moment-timezone';

import { IProjectDetailInfo, IProjectInfo } from '../models/IProjectInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { IProject, IProjectDetail } from '../ServerApi/types/IProject';
import { IProjectUsageInfo } from '../ServerApi/types/IUsageInfo';
import { INamedItem } from '../ServerApi/types/resourceParts';
import { MapperHelper } from './MapperHelper';
import { UserMapper } from './UserMapper';

export module ProjectMapper {

  const M = MapperHelper;

  export function map(
    serverApiProjects: IProject[],
    users: _.Dictionary<IUserInfo>,
    favoriteProjects: _.Dictionary<any> = {}
  ): IProjectInfo[] {
    return _.map(serverApiProjects, (p: IProject) => mapOne(p, users[p.ownerId], !!favoriteProjects[p.id]));
  }

  export function mapOne(
    p: IProject,
    owner?: IUserInfo,
    favorite?: boolean
  ): IProjectInfo {
    return {
      controlledPermissionsEnabled: p.controlledPermissionsEnabled,
      nestedProjectsPermissionsIncluded: p.nestedProjectsPermissionsIncluded,
      createdAt:                    M.toDate(p.createdAt),
      datasourceCount:              M.toNumber(p.datasourceCount),
      description:                  p.description,
      id:                           p.id,
      luid:                         p.luid,
      name:                         p.name,
      owner:                        UserMapper.mapOne(owner),
      viewCount:                    M.toNumber(p.viewCount),
      workbookCount:                M.toNumber(p.workbookCount),
      childProjectCount:            M.toNumber(p.childProjectCount),
      parentId:                     p.parentProjectId,
      topLevelProject:              p.topLevelProject,
      updatedAt:                    M.toDate(p.updatedAt),
      favorite:                     favorite,
      contentType:                  'project',
      usageInfoMaxValues:           <IProjectUsageInfo>{},
      usageInfo:                    (_.isNumber(p.favoritesTotal) && {favoritesTotal: M.toNumber(p.favoritesTotal)}) || <IProjectUsageInfo>{}
    };
  }

  export function mapDetail(p: IProjectDetail): IProjectDetailInfo {
    return {
      controlledPermissionsEnabled: p.controlledPermissionsEnabled,
      nestedProjectsPermissionsIncluded: p.nestedProjectsPermissionsIncluded,
      createdAt:                    M.toDate(p.createdAt),
      description:                  p.description,
      id:                           p.id,
      name:                         p.name,
      owner:                        UserMapper.mapOne(p.owner),
      parentId:                     p.parentProjectId,
      topLevelProject:              p.topLevelProject,
      updatedAt:                    M.toDate(p.updatedAt),
      favorite:                     p.favorite,
      contentType:                  'project',
      luid:                         p.projectLuid
    };
  }

  export function mapName(p: INamedItem): INamedItemInfo {
    return {
      id:          p.id,
      name:        p.name,
      contents:    p.contents
    };
  }

  export function mapNames(serverApiProjects: INamedItem[]): INamedItemInfo[] {
    return _.map(serverApiProjects, mapName);
  }

  export function mapFromCRASS(content: any): IProjectInfo{
    return {
        controlledPermissionsEnabled: content.controlledPermissionsEnabled,
        nestedProjectsPermissionsIncluded: content.nestedProjectsPermissionsIncluded,
        createdAt:                    M.toDate(content.createdTime) || M.toDateFromTimeOffsetObject(content.createdTime),
        datasourceCount:              0,
        description:                  content.description,
        id:                           content.id + '',
        luid:                         content.luid,
        name:                         content.title,
        viewCount:                    0,
        workbookCount:                0,
        childProjectCount:            0,
        parentId:                     content.parentProjectId,
        topLevelProject:              content.topLevelProject,
        updatedAt:                    M.toDate(content.modifiedTime) || M.toDateFromTimeOffsetObject(content.modifiedTime),
        favorite:                     false,
        contentType:                  'project',
        usageInfoMaxValues:           <IProjectUsageInfo>{},
        usageInfo:                    <IProjectUsageInfo>{},
        owner: {
            id: content.ownerId + '',
            displayName: content.ownerName || '',
            username: content.ownerAlias || '',
            domainName: content.ownerDomain,
            isHiddenInternalUser: false
        }
      };
  }
}
